import { productCardBlurb } from '#bv/lib/productCardCopy'
import type { Product } from '#bv/data/products'

/** Short line for tier rows (shop modal, hub PDP, sibling links). */
export function tierListingBlurb(product: Product, fallbackBlurb?: string): string | null {
  const fromCard = productCardBlurb(product)
  if (fromCard) return fromCard
  const raw = fallbackBlurb?.trim()
  if (!raw) return null
  const name = product.name.trim()
  let text = raw
  if (name) {
    text = text.replace(new RegExp(`^${escapeRegExp(name)}\\s*[—–-]\\s*`, 'i'), '')
  }
  text = text.replace(/\s*—\s*\$\d+(?:\.\d{2})?\s*$/i, '').trim()
  return text || null
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
